export default [
  { title: 'Users', routeName: 'users' },

];
